import React, { FunctionComponent } from 'react'
import { Text, Accordion } from '@afterpaytouch/core'

interface PayMonthlyAccordionProps {
  headerText: string
  contentText: string
  onAccordionChange: () => void
}

export const PayMonthlyAccordion: FunctionComponent<PayMonthlyAccordionProps> = ({ headerText, contentText, onAccordionChange }) => (
  <Accordion id='pay-monthly-faq' testNameSpace='pay-monthly-accordion' onChange={onAccordionChange}>
    <Accordion.Button>
      <Text size='M' bold>
        {headerText}
      </Text>
    </Accordion.Button>
    <Accordion.Details>
      <Text size='S'>{contentText}</Text>
    </Accordion.Details>
  </Accordion>
)
